import { render, staticRenderFns } from "./edit-bulk-message-template-dialog.vue?vue&type=template&id=5f802905&scoped=true&"
import script from "./edit-bulk-message-template-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-bulk-message-template-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f802905",
  null
  
)

export default component.exports